import { lazy } from 'react';

// Types
import { EmptyBasketNotificationProps as LazyComponentProps } from './EmptyBasketNotification.types';

// Components
import withSuspense, { lazyRetry } from '@components/suspense';

const LazyComponent = lazy(() =>
  lazyRetry(() => import(/* webpackChunkName: "emptyBasketNotification" */ './EmptyBasketNotification')),
);

const LazyComponentWithSuspense = withSuspense<LazyComponentProps>(LazyComponent, 'EmptyBasketNotification');

// Exports
export default LazyComponentWithSuspense;
export { LazyComponent as EmptyBasketNotification };
